import React from 'react'
import PropTypes from 'prop-types'

const CircleCheckIcon = ({ className }) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M7 10L9 12L13 8M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
      stroke="inherit"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

CircleCheckIcon.defaultProps = {
  className: null,
}

CircleCheckIcon.propTypes = {
  className: PropTypes.string,
}

export default CircleCheckIcon
